import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Card from "../../components/common/Card";
//import AdvertisersTable from "./AdvertisersTable";
import Tab from "../../components/common/Tab/Tab";

import { Container, CardWrapper } from "./AdvertisersStyles";
import { getTopBoard } from "../../redux/slices/advertiserSlice";

const Advertisers = () => {
  const dispatch = useDispatch();
  const { topBoard } = useSelector((state) => state.advertiser);
  //console.log(topBoard);

  useEffect(() => {
    dispatch(getTopBoard());
  }, [dispatch]);

  return (
    <Container>
      <div className="header">
        <div className="texts">
          <h3>Advertisers</h3>
          <p>Keep track of advertiser activity.</p>
        </div>

        <div className="link-buttons">
          {/* <Link className="see-more" to="/campaigns">
            Export
          </Link> */}
          <Link className="add-campaign" to="/create-advertiser">
            + Add advertisers
          </Link>
        </div>
      </div>

      <CardWrapper>
        <Card
          text={"Total no of advertisers"}
          totalCount={topBoard?.totalAdvertisers}
        />
        <Card
          text={"Active advertisers"}
          totalCount={topBoard?.approvedAdvertisers}
        />
        <Card
          text={"Pending advertisers"}
          totalCount={topBoard?.pendingAdvertisers}
        />
      </CardWrapper>
      <Tab advertiser />
    </Container>
  );
};

export default Advertisers;
